const transformHour = (hour) => {
  let str = hour.split(':');
  str.splice(2, 1);
  return str.join(':');
};

export default transformHour;
